<div class="loader-container" *ngIf="showLoader">
  <div class="loader"></div>
</div>

<mcg-window #form [title]="title()" [actions]="actions()"
  (actionButtonClicked)="actionButtonClicked($event)"
  (windowClosed)="onClose()" (windowOpened)="onOpen()"
  (windowExpanded)="onExpand()" (windowCollapsed)="onCollapse()">
  <jqxRibbon #elemRibbon [theme]="environment.tema" [position]="'top'" (onChange)="changeTab($event)">
    <ul style="width: 100%; text-align: left">
      <li>
        {{ translate("Informacion") }}
      </li>
      <li>
        {{ translate("Detalle") }}
      </li>
      <li>
        {{ translate("Perifericos_IOT") }}
      </li>
      <li>
        {{ translate("Instalaciones") }}
      </li>
      <li>
        {{ translate("Gestion") }}
      </li>
      <li>
        {{ translate("Historico_coordenadas") }}
      </li>
    </ul>

    <div style="height: 100%">
      <div class="row tab"
        style="background-color: transparent; display: flex; padding: 0%; overflow-y: hidden !important;">
        <app-elements-edit-informacion #tabInformacion [form]="form" [elemEdit]="elemEdit"
          [crearMultiples]="crearMultiples" [map]="map" [expanded]="expanded" [closed]="closed"
          (catEquipSelecChange)="catEquipSelec = $event">
        </app-elements-edit-informacion>
      </div>

      <div class="row tab" style="background-color: transparent; padding: 0%; overflow-y: hidden !important;">
        <app-elements-edit-detalle #tabDetalle [elemEdit]="elemEdit" [expanded]="expanded" [closed]="closed">
        </app-elements-edit-detalle>
      </div>

      <div style="overflow: hidden; background-color: transparent;">
        <app-elements-edit-perifericos #tabPeriferico [elemEdit]="elemEdit" [expanded]="expanded" [closed]="closed">
        </app-elements-edit-perifericos>
      </div>

      <div class="row tab" style="overflow: hidden; background-color: transparent">
        <app-elements-edit-instalaciones #tabInstalacion [elemEdit]="elemEdit">
        </app-elements-edit-instalaciones>
      </div>

      <div style="overflow: hidden; background-color: transparent">
        <app-elements-edit-gestion #tabGestion [elemEdit]="elemEdit" [expanded]="expanded" [closed]="closed">
        </app-elements-edit-gestion>
      </div>

      <div style="overflow: hidden; background-color: transparent">
        <app-elements-edit-historico-coordenadas #tabHistoricoCoordenadas [elemEdit]="elemEdit" [form]="form"
          [map]="map">
        </app-elements-edit-historico-coordenadas>
      </div>
    </div>
  </jqxRibbon>
</mcg-window>
